import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import handPointRight from '../../../Constant/Icons/HandPointRight.svg';
import { serverUrl } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';
import Loader from '../../../Constant/Custom/Loader';

function HomePage({ handleProceed }) {

    const { auth } = useContext(AuthContext);


    const instructions = [
        {
            english: "Ensure all personal information is accurate and up-to-date.",
            tamil: "அனைத்து தனிப்பட்ட தகவல்களும் துல்லியமாகவும் புதுப்பித்ததாகவும் இருப்பதை உறுதிசெய்யவும்."
        },
        {
            english: "Provide your full legal name as per official documents.",
            tamil: "அதிகாரப்பூர்வ ஆவணங்களின்படி உங்கள் முழு சட்டப்பூர்வ பெயரை வழங்கவும்."
        },
        {
            english: "Fill out all required fields completely. Incomplete forms may delay processing.",
            tamil: "தேவையான அனைத்து புலங்களையும் முழுமையாக நிரப்பவும். முழுமையற்ற படிவங்கள் செயலாக்கத்தை தாமதப்படுத்தலாம்."
        },
        {
            english: "Double-check your contact information for any errors to avoid communication issues.",
            tamil: "தகவல்தொடர்பு சிக்கல்களைத் தவிர்க்க ஏதேனும் பிழைகள் உள்ளதா என உங்கள் தொடர்புத் தகவலை இருமுறை சரிபார்க்கவும்."
        },

        {
            english: "Review all entered information before submitting the form to ensure its accuracy.",
            tamil: "படிவத்தைச் சமர்ப்பிப்பதற்கு முன், அதன் துல்லியத்தை உறுதிப்படுத்த, உள்ளிட்ட அனைத்துத் தகவலையும் மதிப்பாய்வு செய்யவும்."
        },
        {
            english: "Submit the form by the specified deadline to ensure timely consideration for counselling.",
            tamil: "ஆலோசனைக்கான சரியான நேரத்தில் பரிசீலிக்கப்படுவதை உறுதிசெய்ய, குறிப்பிட்ட காலக்கெடுவிற்குள் படிவத்தை சமர்ப்பிக்கவும்."
        }
    ];


    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const checkSession = async () => {
            try {
                const storedUser = auth.user;
                // console.log(storedUser);
                if (!storedUser) {
                    throw new Error('No active session found');
                }

                // const userData = JSON.parse(storedUser);

                if (!storedUser.appno || !storedUser.mobile || !storedUser.email) {
                    throw new Error('Incomplete session data');
                }

                const dataToSend = {
                    appno: storedUser.appno,
                    mobile: storedUser.mobile,
                    email: storedUser.email
                };
                const response = await axios.post(`${serverUrl}/api/user`, dataToSend, { withCredentials: true });

                if (response.status === 200 && response.data) {
                    // console.log(response.data);
                    setUser(response.data);
                    setLoading(false);
                } else {
                    throw new Error('Failed to load user data from the server');
                }

            } catch (error) {
                console.error('Error fetching session:', error);
                setError(error.message);
                navigate('/login'); // Redirect to login if session check fails
            } finally {
                setLoading(false);
            }
        };

        checkSession();
    }, [navigate]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    // Render the user dashboard if user data is available
    return (
        <div className='homePage'>
            <div className='welcomeApplicant'>
                {user ? (
                    <>
                        <h1>Welcome, {user.userName}!</h1>
                        <div>
                            <p><b>Applicaion No: </b>{user.appno}</p>
                            <p><b>Email ID: </b>{user.email}</p>
                            <p><b>Date of Reg: </b>{user.dateOfReg}</p>
                        </div>
                    </>
                ) : (
                    <div>No user data available</div>
                )}
            </div>
            <div className='homeGeneralInstruction'>
                <h3>General Instructions</h3>
                <ul>
                    {instructions.map((instruction, index) => (
                        <li key={index}>
                            <img src={handPointRight} alt='*' width={15} height={15} />
                            {instruction.english} <br />
                            {instruction.tamil}

                        </li>
                    ))}
                </ul>
            </div>
            <div className='ProceedButton'>
                <Link to="/dashboard/personalInfo"><button>Click Here to Proceed</button>
                </Link>
            </div>
        </div>
    );
}

export default HomePage;
